/* Silent story loops. The still image is always rendered; a loop is fetched only when it comes
   near the viewport, plays while visible and pauses off-screen. Reduced motion and data saver
   keep the still only. Loaded as a module, so several chapters share one copy. */
const quiet = matchMedia('(prefers-reduced-motion: reduce)');
const saveData = navigator.connection?.saveData === true;
const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  for (const {target: video, isIntersecting} of entries) {
    if (!isIntersecting) { if (!video.paused) video.pause(); continue; }
    if (quiet.matches) continue;
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    video.play().catch(() => {});
  }
}, {rootMargin: '200px 0px'}) : null;

const setup = (root) => {
  if (!observer || saveData) return;
  for (const video of root.querySelectorAll('video.gv-chapter-loop[data-src]')) {
    if (video.dataset.loopReady) continue;
    video.dataset.loopReady = '1';
    video.addEventListener('playing', () => video.classList.add('is-playing'));
    // Theme editor only: say so when the loop file can't be loaded (usually a typo in its file name).
    if (window.Shopify?.designMode) {
      video.addEventListener('error', () => {
        const figure = video.closest('figure');
        if (!figure || figure.querySelector('.gv-editor-hint')) return;
        const hint = document.createElement('p');
        hint.className = 'gv-editor-hint';
        hint.textContent = 'סרטון הלולאה לא נטען. בדקו את שם הקובץ ב-Content › Files: ' + decodeURIComponent(video.dataset.src.split('/').pop().split('?')[0]) + '. ההודעה הזו מוצגת רק בעורך.';
        figure.append(hint);
      }, {once: true});
    }
    observer.observe(video);
  }
};

quiet.addEventListener?.('change', () => {
  for (const video of document.querySelectorAll('video.gv-chapter-loop.is-playing')) {
    if (quiet.matches) { video.pause(); video.classList.remove('is-playing'); }
  }
});
setup(document);
document.addEventListener('shopify:section:load', (event) => setup(event.target));
